/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import FranchiseOrderTab from "./FranchiseOrderTab";
import SaleOrderTab from "./SaleOrderTab";
import SaleOrderChildTab from "./SaleOrderChildTab";
import { SearchPincodeList, ErrorMessageFromRedux, StartMainCommonLoader } from "../../../redux/actions/adminActions";
import { useDispatch, useSelector } from "react-redux";
import StocktransferTab from "./StocktransferTab";
import wsSend_request from "../../../Api/ws/ws_request";
import { WebSocketContext } from "../../../App";
import CommonLoader from "../../Common/CommonLoader";
import BundlesOrders from "./BundlesOrders";
import { Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const PurchaseOrder = (props) => {
    const LocationURL = useLocation()?.pathname?.split("/")[1];
    const Dispatch = useDispatch();
    const { websocket } = useContext(WebSocketContext);
    const [ Tab, setTab ] = useState("franchise_order");
    const { selfInfo, device_id, commonMainLoader } = useSelector((state) => state.adminReducers);
    const PermissionsAccess = selfInfo?.user?.permissions_access;
    const [ PermissionStockInwardModule, setPermissionStockInwardModule ] = useState({
        open: false,
        permissionStockInward: "",
    });

    useEffect(() => {
        return () => {
            Dispatch(SearchPincodeList({}));
            Dispatch(ErrorMessageFromRedux({
                API: "",
                Error: "",
            }));
            Dispatch(StartMainCommonLoader({
                url: "",
                loader: false
            }));
        };
    }, [ Tab ]);

    
    useEffect(() => {
        if(LocationURL === "afs-so-creation") {
            setPermissionStockInwardModule({
                ...PermissionStockInwardModule,
                open: false,
                permissionStockInward: "Spares",
            });
            setTab("sale_order");
        } else if(LocationURL === "SO-creation") {
            setPermissionStockInwardModule({
                ...PermissionStockInwardModule,
                open: true,
                permissionStockInward: "",
            });
        };
    }, [ LocationURL ]);

     // Permission Add Stock fucntion
     const PermissionAddStock = (value) => {
        setPermissionStockInwardModule({
            ...PermissionStockInwardModule,
            open: false,
            permissionStockInward: value,
        });
    };

    // Stock inward modal permission 
    const onClose = () => {
        setPermissionStockInwardModule({
            ...PermissionStockInwardModule,
            open: false,
            permissionStockInward: "",
        });
        window.history.back();
    };

    // GET ALL FRANCHISE LIST API
    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || (
            (PermissionsAccess?.OrderManagement[1]?.Edit || PermissionsAccess?.OrderManagement[1]?.View) || 
            (PermissionsAccess?.AFSOrderManagement[1]?.Edit || PermissionsAccess?.AFSOrderManagement[1]?.View) || 
            (PermissionsAccess?.OrderManagement[20]?.Edit || PermissionsAccess?.OrderManagement[20]?.View))
        ) {
            if(Tab === "franchise_order" || Tab === "sale_order" || Tab === "ecom_order") {
                let param = { 
                    "transmit": "broadcast", 
                    "url": "franchise_list",
                    "request" : { 
                        "status" : true, 
                        "limit" : 5000,
                        "page_no" : 1, 
                        "search" : ""
                    },
                    "DeviceId" : device_id
                };
                wsSend_request(websocket, param);
            };
        };
    }, [ websocket, LocationURL === "SO-creation", LocationURL === "afs-so-creation" ]);

    // GET ALL CATEGORY API
    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || ((PermissionsAccess?.OrderManagement[1]?.Edit || PermissionsAccess?.OrderManagement[1]?.View) || (PermissionsAccess?.AFSOrderManagement[1]?.Edit || PermissionsAccess?.AFSOrderManagement[1]?.View) || (PermissionsAccess?.OrderManagement[20]?.Edit || PermissionsAccess?.OrderManagement[20]?.View)))  {
            if(Tab === "franchise_order" || Tab === "sale_order" || Tab === "stock_transfer") {
                let param = { 
                    "transmit": "broadcast", 
                    "url": "category_list",
                    "request" : { 
                        "status" : true,
                        "limit" : 5000,
                        "page_no" : 1, 
                        "search" : ""
                    },
                    "DeviceId" : device_id
                };
                wsSend_request(websocket, param);
            };
        };
    }, [ websocket, LocationURL === "SO-creation", LocationURL === "afs-so-creation" ]);

    // GET ALL SUB CATEGORY API
    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || ((PermissionsAccess?.OrderManagement[1]?.Edit || PermissionsAccess?.OrderManagement[1]?.View) || (PermissionsAccess?.AFSOrderManagement[1]?.Edit || PermissionsAccess?.AFSOrderManagement[1]?.View) || (PermissionsAccess?.OrderManagement[20]?.Edit || PermissionsAccess?.OrderManagement[20]?.View)))  {
            if(Tab === "franchise_order" || Tab === "sale_order" || Tab === "stock_transfer") {
                let param = { 
                    "transmit": "broadcast", 
                    "url": "subcategory_list",
                    "request" : { 
                        "status" : true, 
                        "limit" : 5000,
                        "page_no" : 1, 
                        "search" : ""
                    },
                    "DeviceId" : device_id
                };
                wsSend_request(websocket, param);
            };
        };
    }, [ websocket, LocationURL === "SO-creation", LocationURL === "afs-so-creation" ]);

    // GET ALL PRODUCT LIST API
    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || ((PermissionsAccess?.OrderManagement[1]?.Edit || PermissionsAccess?.OrderManagement[1]?.View) || (PermissionsAccess?.AFSOrderManagement[1]?.Edit || PermissionsAccess?.AFSOrderManagement[1]?.View) || (PermissionsAccess?.OrderManagement[20]?.Edit || PermissionsAccess?.OrderManagement[20]?.View)))  {
            if(Tab === "franchise_order" || Tab === "sale_order" || Tab === "stock_transfer") {
                let param = {
                  transmit: "broadcast",
                  url: "product_list",
                  request: {
                    status: true,
                    limit: 5000,
                    page_no: 1,
                    search: "",
                    fetch_brand: true,
                    fetch_pr_wh: true,
                  },
                  DeviceId: device_id,
                };
                wsSend_request(websocket, param);
            };
        };
    }, [ websocket, LocationURL === "SO-creation", LocationURL === "afs-so-creation" ]);

    // SPARE ITEM LIST API CALL
    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.AFSOrderManagement?.[1]?.Edit || PermissionsAccess?.AFSOrderManagement?.[1]?.View))  {
            if(PermissionStockInwardModule?.permissionStockInward === "Spares" && LocationURL === "afs-so-creation") {
                let param = { 
                    "transmit": "broadcast", 
                    "url": "spare_item_list",
                    "request" : { 
                        "limit" : 5000,
                        "page_no" : 1, 
                        "search" : null,
                        "order_by": "-updated_at"
                    },
                    "DeviceId" : device_id
                };
                wsSend_request(websocket, param);
            };
        };
    }, [ websocket, PermissionStockInwardModule?.permissionStockInward, LocationURL ]);
 
    // GET ALL SALE TYPE LIST API
    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.AFSOrderManagement?.[1]?.Edit || PermissionsAccess?.AFSOrderManagement?.[1]?.View))  {
            if(PermissionStockInwardModule?.permissionStockInward === "Spares" && LocationURL === "afs-so-creation") {
                let param = { 
                    "transmit": "broadcast", 
                    "url": "sale_type_list",
                    "request" : { 
                        "limit" : 20,
                        "page_no" : 1, 
                        "order_by": "-updated_at"
                    },
                    "DeviceId" : device_id
                };
                wsSend_request(websocket, param);
            };
        };
    }, [ websocket, PermissionStockInwardModule?.permissionStockInward, LocationURL ]);

    // GET ALL BUNDLE LIST API 
    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.OrderManagement[1]?.Edit || PermissionsAccess?.OrderManagement[1]?.View)) {
            if(PermissionStockInwardModule?.permissionStockInward === "Bundles") {
                let param = { 
                    "transmit": "broadcast", 
                    "url": "bundle_list",
                    "request" : { 
                        "limit" : 5000,
                        "page_no" : 1, 
                        "order_by":"-updated_at"
                    },
                    "DeviceId" : device_id
                };
                wsSend_request(websocket, param);
            };
        };
    }, [ websocket, PermissionStockInwardModule?.permissionStockInward, LocationURL === "SO-creation", LocationURL === "afs-so-creation" ]);

    useEffect(() => {
        if(PermissionStockInwardModule?.permissionStockInward === "Others") {
            setTab("ecom_order")
        } else if(PermissionStockInwardModule?.permissionStockInward === "E-Bikes,Accessories") {
            setTab("franchise_order")
        } else if(PermissionStockInwardModule?.permissionStockInward === "Spares") {
            setTab("sale_order")
        };
    }, [ PermissionStockInwardModule?.permissionStockInward ]);

    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.OrderManagement[20]?.Edit || PermissionsAccess?.OrderManagement[20]?.View)) {
            setTab("franchise_order");
        } else if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.OrderManagement[21]?.Edit || PermissionsAccess?.OrderManagement[21]?.View)) {
            setTab("sale_order");
        };
    }, [  ]);

    return(<section className="Main_section so_creations_details">
        <div className="MainHeader">
            {(selfInfo?.user?.user_type === 'regional_manager' || selfInfo?.user?.user_type === 'regional_sales_team_rm' || selfInfo?.user?.user_type === 'regional_sales_team_asm') ? (<ul className="MainHeader_Tab">
                {PermissionStockInwardModule?.permissionStockInward === "Spares" ? (<li className={"active"} onClick={() => setTab("sale_order")}>
                    AFS Creations
                </li>) : (<li className={Tab === "franchise_order" ? "active" : ""} onClick={() => setTab("franchise_order")}>Franchise Order</li>)}
            </ul>) : (<ul className="MainHeader_Tab">
                {PermissionStockInwardModule?.permissionStockInward === "Spares" && (<>
                    <li className={"active"} onClick={() => setTab("sale_order")}>
                        AFS Creations
                    </li>
                </>)}
                {PermissionStockInwardModule?.permissionStockInward === "E-Bikes,Accessories" && (<>
                    <li className={Tab === "franchise_order" ? "active" : ""} onClick={() => setTab("franchise_order")}>Franchise Order</li>
                    <li className={Tab === "distributor_order" ? "active" : ""} onClick={() => setTab("distributor_order")}>Distributor Order</li>
                    <li className={Tab === "ecom_order" ? "active" : ""} onClick={() => setTab("ecom_order")}>Marketplace Orders</li>
                    <li className={Tab === "stock_transfer" ? "active" : ""} onClick={() => setTab("stock_transfer")}>Stock Transfer</li>
                </>)}
                {PermissionStockInwardModule?.permissionStockInward === "Others" && (<>
                    <li className={Tab === "ecom_order" ? "active" : ""} onClick={() => setTab("ecom_order")}>Marketplace Orders</li>
                    <li className={Tab === "stock_transfer" ? "active" : ""} onClick={() => setTab("stock_transfer")}>Stock Transfer</li>
                </>)}
                {PermissionStockInwardModule?.permissionStockInward === "Bundles" && (<>
                    <li className={Tab === "franchise_order" ? "active" : ""} onClick={() => setTab("franchise_order")}>Franchise Order</li>
                    <li className={Tab === "bundles_orders" ? "active" : ""} onClick={() => setTab("bundles_orders")}>Bundles Orders</li>
                </>)}
            </ul>)}
        </div>

        {PermissionStockInwardModule?.permissionStockInward !== "" && (<React.Fragment>
            {(Tab === "franchise_order" || Tab === "distributor_order") ? (<>
                <FranchiseOrderTab 
                    PermissionStockInwardModule={PermissionStockInwardModule} 
                    setPermissionStockInwardModule={setPermissionStockInwardModule} 
                    DistributorAllow={Tab === "distributor_order"}
                />
            </>) : Tab === "sale_order" ? (<>
                <SaleOrderTab 
                    PermissionStockInwardModule={PermissionStockInwardModule} 
                    setPermissionStockInwardModule={setPermissionStockInwardModule} 
                />
            </>) : Tab === "stock_transfer" ? (<>
                <StocktransferTab />
            </>) : Tab === "ecom_order" ? (<>
                <SaleOrderChildTab />
            </>) : (<>
                <BundlesOrders />
            </>)}
        </React.Fragment>)}
        
        {(commonMainLoader?.url === "order_add" && commonMainLoader?.loader) && (<CommonLoader />)}

        {PermissionStockInwardModule?.open && (<Modal show={PermissionStockInwardModule?.open} onHide={onClose} className='commonModal commonModalStockInward' centered>
            <Modal.Header className='border-bottom-0 bb-0 pb-0' closeButton>
                <Modal.Title className='h5'>Order Category  <span className='text-danger' >*</span></Modal.Title>
            </Modal.Header>
            <div className='p-3 btn-groups-main' id="btn-groups-main-id">
                {(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.OrderManagement[1]?.Edit || PermissionsAccess?.OrderManagement[1]?.View)) && (<button className="btn" onClick={() => PermissionAddStock("E-Bikes,Accessories")}>E-Bikes + Accessories</button>)}
                {LocationURL === "afs-so-creation" && (<React.Fragment>
                    {(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.OrderManagement[20]?.Edit || PermissionsAccess?.OrderManagement[20]?.View) || (PermissionsAccess?.OrderManagement[21]?.Edit || PermissionsAccess?.OrderManagement[21]?.View)) && (<button className="btn" onClick={() => PermissionAddStock("Spares")} >Spares/AFS</button>)}
                </React.Fragment>)}
                {(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.OrderManagement[1]?.Edit || PermissionsAccess?.OrderManagement[1]?.View)) && (<button className="btn" onClick={() => PermissionAddStock("Bundles")}>Bundles</button>)}
                {(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.OrderManagement[1]?.Edit || PermissionsAccess?.OrderManagement[1]?.View)) && (<button className="btn" onClick={() => PermissionAddStock("Others")}>Others...</button>)}
            </div>
        </Modal>)}
    </section>)
}

export default PurchaseOrder;